/**
 * Regular expression to match UUIDs in the format: <uuid>
 * Used to extract candidate profile IDs from text content
 */
export const UUID_REGEX =
  /<([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})>/gi;

/**
 * Regular expression to match specific suggestion tags:
 * <specific_suggestion>content</specific_suggestion>, or with an attribute,
 * <specific_suggestion field="location">content</specific_suggestion>.
 *
 * The attribute group is deliberately non-capturing. Several callers index the
 * groups by position, and one composes this source with UUID_REGEX and
 * BLOCKQUOTE_REGEX and reads `match[2]`, so adding a capturing group here would
 * silently shift what every one of them reads.
 */
export const SPECIFIC_SUGGESTION_REGEX =
  /<specific_suggestion(?:\s[^>]*)?>(.*?)<\/specific_suggestion>/g;

/**
 * The `field` a removal suggestion acts on, read off a matched opening tag.
 *
 * A chip's label is model-written prose in the recruiter's language, so it
 * cannot be matched back to a filter. The field key can, which is what lets a
 * "remove the Location filter" chip clear that filter rather than only sending
 * text. Not global: applied to one match at a time.
 */
export const SPECIFIC_SUGGESTION_FIELD_REGEX =
  /<specific_suggestion\s[^>]*\bfield="([^"]+)"/;

/**
 * Regular expression to match blockquote tags: <blockquote>content</blockquote>
 * The agent reply opens by quoting the search it ran -- the semantic query, and
 * the filters in plain English -- inside these. Content spans newlines, so this
 * uses [\s\S] rather than `.`.
 */
export const BLOCKQUOTE_REGEX = /<blockquote>([\s\S]*?)<\/blockquote>/g;
